import { breakpoints } from './utils/breakpoints';

class Mediarichtext {
    constructor() {
        this.class = {
            module: '.module-media-richtext',
            parallaxImage: '.parallax-image',
            moduleYellowBg: '.bg_yellow',
            optionalImage: '.media-image-opt',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        if (document.querySelector(this.class.module)) {
            new Rellax('.rellax', {
                wrapper: '.media-richtext-container',
                speed: -2,
            });
            this.checkOptionalImage();
            window.addEventListener('resize', this.checkOptionalImage.bind(this));
        }
    }

    checkOptionalImage() {
        const modules = document.querySelectorAll(this.class.module);
        modules.forEach((module) => {
            if (module.querySelector(this.class.optionalImage)) {
                const parent = module.querySelector(this.class.moduleYellowBg);
                const child = parent.querySelector(this.class.optionalImage);
                if (window.innerWidth >= breakpoints.md) {
                    const parentHeight = parent.clientHeight;
                    const childHeight = child.clientHeight;
                    if (childHeight > (parentHeight - 50)) {
                        child.style.top = 'unset';
                        child.style.bottom = '-51px';
                        child.style.transform = 'none';
                    }
                } else {
                    child.removeAttribute('style');
                    child.style.bottom = '-32px';
                }
            }
        });
    }
}

export default new Mediarichtext();
